import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './assets/styles/colors.css';
import Header from './components/common/Header/Header';
import { AuthProvider } from './context/AuthContext';
import { menu } from './constants';
import ForgotPassword from './pages/accountSettings/ForgotPassword/ForgotPassword';
import PasswordReset from './pages/accountSettings/PasswordReset/PasswordReset';
import Settings from './pages/accountSettings/Settings/Settings';
import Signup from './pages/accountSettings/Signup/Signup';
import Guide from './pages/engineer/Guide/Guide';
import LoginEn from './pages/engineer/Signin/Signin';
import MyPage from './pages/engineer/EngineerInfo/Main';
import LoginMng from './pages/mng/Signin/Signin';
import EngineerListForMng from './pages/mng/EngineerList/EngineerList';
import EngineerListForPublic from './pages/public/EngineerList/EngineerList';
import WebCv from './pages/public/WebCv/WebCv';
import WebCvPreview from './pages/engineer/WebCvPreview/WebCvPreview';
import WebCvPrivate from './pages/error/WebCvPrivate';
import WebCvPDF from './pages/public/WebCv/WebCvPDF/WebCvPDF';
import EngineerListByLoggedInAsEngineer from './pages/engineer/Engineers/EngineerList';
import WebCvByLoggedInAsEngineer from './pages/engineer/WebCv/WebCv';
import Privacy from './pages/engineer/Privacy/Privacy';
import NotFound from './pages/error/NotFound';
import InternalServerError from './pages/error/InternalServerError';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Header />
                <Routes>
                    <Route path="/" element={<Navigate to={menu.ENGINEER.HOME.PATH} />} />
                    {/* 共通 */}
                    <Route path="/signup" element={<Signup />}></Route>
                    <Route path="/signin" element={<LoginEn />}></Route>
                    <Route path="/guide" element={<Guide />}></Route>
                    <Route path="/privacy" element={<Privacy />}></Route>
                    <Route path="/forgot-password" element={<ForgotPassword />}></Route>
                    <Route path="/password-reset/:token" element={<PasswordReset />}></Route>
                    {/* エンジニア */}
                    <Route path="/mypage" element={<MyPage />}></Route>
                    <Route path="/engineers" element={<EngineerListByLoggedInAsEngineer />}></Route>
                    <Route path="/engineers/:random3Id/:random4Id" element={<WebCvByLoggedInAsEngineer />}></Route>
                    <Route path="/preview/:random1Id/:random2Id" element={<WebCvPreview />}></Route>
                    <Route path="/settings" element={<Settings />}></Route>
                    <Route path="/:random1Id/:random2Id" element={<WebCv />}></Route>
                    {/* 管理者 */}
                    <Route path="/mng/signin" element={<LoginMng />}></Route>
                    <Route path="/mng/engineers" element={<EngineerListForMng />}></Route>
                    <Route path="/mng/settings" element={<Settings />}></Route>
                    {/* SES営業用 */}
                    <Route path="/share/engineers" element={<EngineerListForPublic />}></Route>
                    <Route path="/share/:random1Id/:random2Id" element={<WebCv />}></Route>
                    <Route path="/share/pdf" element={<WebCvPDF />}></Route>
                    {/* エラー*/}
                    <Route path="*" element={<NotFound />}></Route>
                    <Route path="/server-error" element={<InternalServerError />}></Route>
                    <Route path="/private" element={<WebCvPrivate />}></Route>
                </Routes>
            </Router >
        </AuthProvider>
    );
}

export default App;